export default __webpack_public_path__ + "static/media/phones.0b206058.png";